<div class="archive-margin-main">
  <article class="specialcase-header" [innerHTML]="archive_header"></article>
  <article class="mt-2 archive-Info" [innerHTML]="archive_body"></article>
  <div class="mt-2 archive-warning-rectangle flex-display">
    <div class="ptbl-32">
      <img src="../../../../assets/icons/warning-orange.svg" class="info-img" alt="Warning Icon">
    </div>
    <article class="ptbr-32 infoWarning" [innerHTML]="archive_note"></article>
  </div>
  <div class="version-group">
    <article class="version-general-header" [innerHTML]="archive_general"></article>
    <div class="mt-8px">
      <ul>
        <li *ngFor="let version of versions" class="basic-access-btn">
          <span class="h-20px highlight-blue border-bottom-help cursor-pointer" (click)="GoToVersion(version)">Version {{version.version}}</span>&nbsp;|&nbsp;
          <span class="archive-Info opacity-5" *ngIf="version.date != 'Current'">{{archive_supersededOn}}</span>
          <span class="archive-Info" *ngIf="version.date == 'Current'">{{version.date}}</span>&nbsp;
          <span class="archive-Info" *ngIf="version.date != 'Current'">{{version.date}}</span>
        </li>
      </ul>
    </div>
  </div>
</div>
